import {DateFormatter} from "../../../services/date";
import {isValidDateObject} from "../../../services/date/validators";

export const bookingItemOption = (accommodationUnit, price) => {
    const {id, type, name, accommodation} = accommodationUnit;
    return {
        id: id,
        type: type,
        name: name,
        accommodation: {name: accommodation.name},
        price
    }
}

export const formDataToAPIRequest = (formData, withPayments=true) => {
    const {
        bookingItems,
        arrival,
        departure,
        adults,
        children,
        petsNumber,
        email,
        name,
        surname,
        nationality,
        deposit,
        depositPayed,
        depositPayedAt,
        depositPaymentType,
        hostNotes,
        bookingCondition,
        bookingConfirmationDocument
    } = formData;

    return {
        adults,
        children,
        petsNumber,
        email,
        name,
        surname,
        nationality,
        hostNotes,
        bookingItemsAttributes: bookingItems.map(b => ({
            arrival: DateFormatter.onlyDateISOString(arrival, null),
            departure: DateFormatter.onlyDateISOString(departure, null),
            bookableType: b.type,
            bookableId: b.id,
            price: b.price
        })),
        bookingFinanceAttributes: {
            deposit: deposit,
            ...(
                withPayments ? {
                        paymentsAttributes: (depositPayed ?
                                [
                                    {
                                        date: depositPayedAt,
                                        paymentType: depositPaymentType,
                                        reasonOfPayment: 'deposit',
                                        amount: deposit,
                                    }
                                ] : []
                        )
                    }
                    : {}
            )
        },
        bookingConditionAttributes: {
            cancellationPolicy: bookingCondition.cancellationPolicy,
            touristTaxPolicy: bookingCondition.touristTaxPolicy,
            refundableUntil: bookingCondition.refundableUntil ? DateFormatter.ISOString(bookingCondition.refundableUntil, null) : null,
            touristTaxUnitPrice: bookingCondition.touristTaxUnitPrice,
            checkInFrom: isValidDateObject(bookingCondition.checkInFrom) ? DateFormatter.timeString(bookingCondition.checkInFrom) : null,
            checkOutBefore: isValidDateObject(bookingCondition.checkOutBefore) ? DateFormatter.timeString(bookingCondition.checkOutBefore) : null,
        },
        bookingConfirmationDocumentAttributes: {
            sendEmailAfterCreate: bookingConfirmationDocument.sendEmailAfterCreate,
        }
    }
}